import react, { useState, useEffect } from "react";
import {
  Container, Grid, Typography, Autocomplete, TextField, Button, Paper, Card, CardContent, CardActionArea
} from "@mui/material";
import { ReadableDateTime } from "../utils/momentUtils";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box } from "@mui/system";

const statusArray = ["Requested", "Running", "Complete", "Error"];
const borderColors = ["grey", "blue", "green", "red"];

export const OptimizationCard = (props) => {
  const {data, onClick} = props;
  const errClick = props.onErrorClick instanceof Function ? props.onErrorClick : false;
  const borderColor = borderColors[data.status];
  const useErrClick = (data.status === 3 && errClick !== false);

  const getShouldDisable = () => {
    let shouldDisable = (data.status === 2) ? false : ((data.status === 3 && errClick !== false) ? false : true);
    return shouldDisable;
  }

  const getActionIcon = () => {
    if (data.status === 2){
      return <ArrowForwardIosIcon/>
    }
    if (useErrClick){
      return <DeleteIcon/>
    }
    
  }
  

  return (
    <Card sx={{border: 1, borderColor: borderColor}}>
      <CardActionArea disabled={getShouldDisable()} 
        onClick={useErrClick ? (() => errClick(data)) : (() => onClick(data))}
      >
       <CardContent>
          <Grid container justifyContent={"center"} spacing={1}>
            <Grid item xs={12}>
              <Typography variant="h5">
                {data.name}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="subtitle1">
                Requested On: {ReadableDateTime(data.dateRequested)}
              </Typography>
              <Typography variant="body1">
                Number of Units: {data.dailyAssignments}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Box sx={{display: "flex", flexGrow: "1"}}>
              <Typography variant="subtitle1">
                Status: {statusArray[data.status]}
              </Typography>
              <Box sx={{display: "flex", flexGrow: "1"}} />
              {data.status >= 2 &&
                getActionIcon()
              }
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}